import { RootState } from '@store/store';

export const selectIsCurrentFormDirty = (state: RootState) =>
  state.ui.isCurrentFormDirty;

export const selectGlobalAlert = (state: RootState) => state.ui.alert;
